






















































































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import Integralrule from '../../../store/entities/integralrule'
    import Qarea from '@/store/entities/qarea'
    import Sarea from '@/store/entities/sarea'
    import Carea from '@/store/entities/carea'
    import Varea from '@/store/entities/varea'
    
     
    
    @Component
    export default class CreateIntegralrule extends AbpBase{
        @Prop({type:Boolean,default:false}) value:boolean;
    
        user:Integralrule=new Integralrule();
    
    //获取初始值
    get qarealist(){
          
            return this.$store.state.integralrule.qarea;
     }
      //区下面的街道
       get qarealst(){
           return this.$store.state.integralrule.qarealst;
       }
       set qarealst(val:number){
            this.$store.commit('integralrule/change_qarealst',val);
       }
       //街道的社区
       get sarealst(){
            return this.$store.state.integralrule.sarealst;
       }
       set sarealst(val:number){
          this.$store.commit('integralrule/change_sarealst',val);           
        
       }
       //社区下的小区
      get carealst(){

            return this.$store.state.integralrule.carealst;
       }
       set carealst(val:number){
          this.$store.commit('integralrule/change_carealst',val);           
        
       }
       //垃圾分类1
get rbt1(){
     
 return this.$store.state.integralrule.rbty1.data;

}
//垃圾分类2
get rbt2(){
     
     
 
 return this.$store.state.integralrule.rbty2list;



}
set rbt2(val:number){
    
          this.$store.commit('integralrule/change_rbty2list',val);           

       }

RbtyChange(val:number){
    var arr=null;
  var th=this;
  var dt= this.$store.state.integralrule.rbty2.data;

  dt.forEach(item=>{
    if( arr==null){
        arr=[];

    }
    if(item.fid==val){
        // th.rbt2=item;
        var id=item.id;
        var name=item.name;
         arr.push(  {id:id ,name:name});
        }
    })
   //th.rbt2=arr;
 this.rbt2=arr;
}

       
     QAreaChange(val:number){
     var dt= this.$store.state.integralrule.qarea;
        dt.forEach(item=>{
        if(item.id==val){
         this.qarealst=item;
     }
          })
       }
      SAreaChange(val:number){
      
       var dt= this.$store.state.integralrule.qarealst.sAreas;
     dt.forEach(item=>{
        if(item.id==val){
         this.sarealst=item;
        }
    })
      }
     CAreaChange(val:number){
 
       var dt= this.$store.state.integralrule.sarealst.cAreas;
    dt.forEach(item=>{
    if(item.id==val){
         this.carealst=item;
        }
    })
       }


        save(){
            console.info(this.user);
            (this.$refs.userForm as any).validate(async (valid:boolean)=>{
                
                if(valid){
                    await this.$store.dispatch({
                        type:'integralrule/create',
                        data:this.user
                    });
                    (this.$refs.userForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input',false);
                }
            })
        }
        cancel(){
            (this.$refs.userForm as any).resetFields();
            this.$emit('input',false);
        }
        visibleChange(value:boolean){
            if(!value){
                this.$emit('input',value);
            }
        }
         
        userRule={
            
         
               vid:[{type:'number', required: true,message:'请选择小区',trigger: 'change'}],
               recyTypeId:[{ required: true,message:'请选择垃圾种类'}],
               score:[{ required: true,message:'请填写分值',trigger: 'blur'}],
               maxNum:[{ required: true,message:'请填写最大值',trigger: 'blur'}],
            
      
        }
        
      
        
    }  

    

    
   
